import { Component, Input, Output, OnInit, EventEmitter, OnDestroy, AfterContentChecked, ChangeDetectorRef} from '@angular/core';
import { PersonneModel } from '../personne/models/personne.model';
import { TypePersonneEnum } from '../personne/enum/type-personne.enum';
import { FormGroup, ControlContainer, UntypedFormGroup } from '@angular/forms';
import { PersonnesForm } from './models/personnes.model';

@Component({
  selector: 'app-personnes',
  templateUrl: './personnes.component.html'
})
export class PersonnesComponent implements OnInit, OnDestroy, AfterContentChecked {

  @Input() name : string;

  _nbEnfants : number;
  @Input()
  set nbEnfants(nbEnf : number) {
    this._nbEnfants = nbEnf;
  }
  get nbEnfants() : number {
    return this._nbEnfants;
  }

  private _isCouple : boolean ;
  @Input() 
  set isCouple(isEnCouple : boolean) {
    this._isCouple = isEnCouple;
  }
  get isCouple() : boolean {
    return this._isCouple;
  }

  typePersonneEnum = TypePersonneEnum;

  personneDemandeur : PersonneModel;
  personneConjoint : PersonneModel;

  parentForm : FormGroup;
  personnesForm : UntypedFormGroup;
  
  @Output() listePersonnesEvent : EventEmitter<Array<PersonneModel>> = new EventEmitter<Array<PersonneModel>>();
  
  @Input() listePersonnes : Array<PersonneModel>;

  constructor(
    private readonly controlContainer: ControlContainer,
    private readonly cd: ChangeDetectorRef) { }

  ngOnInit(): void {
    this.personnesForm =  new FormGroup<PersonnesForm>({});
    this.parentForm = this.controlContainer?.control as FormGroup;
    this.parentForm.addControl(this.name, this.personnesForm);

    // Cas donnée sauvegardée
    if (this.listePersonnes !== undefined && this.listePersonnes.length > 0) {
      this.personneDemandeur = this.listePersonnes[0];
      if (this._isCouple) {
        this.personneConjoint = this.listePersonnes[1];
      }
    }
  }

  ngAfterContentChecked() {
    this.cd.detectChanges();
  }
  
  ngOnDestroy(): void {
    this.parentForm.removeControl(this.name);
  }

  recupererPersonneDemandeur($event : PersonneModel) {
      this.personneDemandeur = $event;
      this.listePersonnes = new Array<PersonneModel>();
      this.listePersonnes.push(this.personneDemandeur);
      if (this._isCouple) {
        this.listePersonnes.push(this.personneConjoint);
      }
      this.listePersonnesEvent.emit(this.listePersonnes);
  }

  recupererPersonneConjoint($event : PersonneModel) {
      this.personneConjoint = $event;
      this.listePersonnes = new Array<PersonneModel>();
      this.listePersonnes.push(this.personneDemandeur);
      if (this._isCouple) {
        this.listePersonnes.push(this.personneConjoint);
      }
      this.listePersonnesEvent.emit(this.listePersonnes);
  }
}
